import * as React from 'react'
import { apiConsumer, IApiConsumer } from '../../data/ApiProvider'
import APageRow from '../../components/atoms/APageRow'
import AButton from '../../components/atoms/AButton'
import { IApiConsumerArray } from '../../data/actions.interface'
import { IApiConsumerEntity } from '../../data/actions.interface'
import { ICustomer } from '../../data/admin/customer.interface'
import { IAdminModify } from '../../data/admin/customer.interface'
import { IModifyReportCustomerAdminDto } from '../../data/admin/customer.dto'
import MForm from '../../components/molecules/MForm'
import AField from '../../components/atoms/AField'
import styled from '../../styledComponents'
import { ARow, ACol } from '../../components/atoms'
import {  getCustomerReportsAdmins, modifyReportCustomerAdmin, getCustomerDetail } from '../../data/admin/customer.actions'
import APageHeader from '../../components/atoms/APageHeader'
import { Field } from 'formik'

interface IModifyCustomerReportAdmin extends IApiConsumer {
    customerId: string
    id: string
    email: string
    back: string
    onSuccess: () => void
    users: IApiConsumerArray<IAdminModify>
    customer: IApiConsumerEntity<ICustomer>
}
const ModifyCustomerReportAdminForm = styled.div`
    background: #ffffff;
    border-radius: 6px;

    & h6 {
        padding: 15px 25px;
        border-bottom: solid 1px #f4f4f4;
    }
    & form {
        padding: 0 25px 15px;
    }
`

class ModifyCustomerReportAdmin extends React.Component<IModifyCustomerReportAdmin> {
    
    handleSubmit = (values: IModifyReportCustomerAdminDto) => {
        return this.props
            .dispatch(modifyReportCustomerAdmin(this.props.id, values))
            .then(this.props.onSuccess)
    }

    render() {
        const { back, id, users , email, customer} = this.props
        console.log("####"+ customer)
        const user =
            users.status === 'success' && users.response.find(u => u.email === email)
        return (
            <div>
                 <APageHeader type= "h6" back={back}> Modify {user && user.email}</APageHeader>
            <ARow>
                <ACol md={3} />
                <ACol md={6}>
                    <ModifyCustomerReportAdminForm>
                    
                        <APageRow>
                            <MForm
                             key={`modify-admin-${id}`}
                            initialValues={{
                                email: user && user.email,
                                firstName: user && user.firstName,
                                lastName: user && user.lastName,
                                report: user && user.report,
                            }}
                             onSubmit={this.handleSubmit}>
                                <AField
                                    name="email"
                                    type="email"
                                    placeholder="Email address"
                                    label="Email address"
                                    value = {user && user.email}
                                />
                                <AField
                                    name="firstName"
                                    type="text"
                                    placeholder = {user && user.firstName}
                                    
                                />
                                <AField
                                    name="lastName"
                                    type="text"
                                    placeholder={user && user.lastName}
                                    
                                />
                             
                                <Field style={{ marginBottom: '10px',width: '290px',   height: '50px', background: '#ffffff' , paddingBottom: '10px', paddingRight: '10px',  paddingTop: '10px'}} component="select" 
                                       name='report'
                                       placeholder={user && user.report}
                                >
                                {customer.response.reports && customer.response.reports.map((item, index) => (
                                 <option value={item.url} selected={user && user.report === item.url}>{item.name}</option>
                                ))}
                                                                                         
                                </Field>
                             
                                <AButton type="submit" block color="primary">
                                    Modify
                                </AButton>
                            </MForm>
                        </APageRow>
                    </ModifyCustomerReportAdminForm>
                </ACol>
            </ARow>
            </div>
        )
    }
}

export default apiConsumer({
    users: props => getCustomerReportsAdmins(),
    customer: props => getCustomerDetail('me'),
})(ModifyCustomerReportAdmin)
